/**
*  Date    : 2022/11/16
*  Author  : zhuql
*  Declare : index  自定义toast
*/

import React, { useEffect } from 'react';

import './ToastModal.scss';

export default function ToastModal(props) {
  const { closeToast = () => { }, isShowToast, duration = 1000, iconUrl = '', content = '收藏成功', top = null, left = null } = props;

  useEffect(() => {
    if(isShowToast) {
      setTimeout(() => {
        closeToast && closeToast();
      }, duration);
    }

  }, [isShowToast]);

  if(!isShowToast) {
    return <div />;
  }

  return (
    <div className="ToastModal">
      <div className="toast-box" style={{ top: `${top || 50}%`, left: `${left || 50}%`, transform: `translateX(-${left || 50}%)` }}>
        <div className="box">
          {
            iconUrl && <img className="toast-icon" src={iconUrl} />
          }
          {
            content &&
          <span className="toast-title">{content}</span>
          }
        </div>

      </div>
    </div>
  );
}